import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { themes, images } from '../../assets';

export const Column = styled.div`
  display: flex;
  align-items: center; 
  justify-content: space-evenly;
  position: absolute;
  flex-direction: line;
  background-color: white;
  height: 100%;
  width: 100%;

  @media (max-width: ${(props) => props.theme.breakpoints.tablet}){
    flex-direction: column;
    /* height: 100%; */
  }
  
  @media (max-height: 900px) {
    height: 900px;
  }
`;

export const ContentContainer = styled.div`
  background-image: ${images.IconInfo};
  position: relative;
  top: 90px;
  left: 300px;
  align-items: center;
  margin: auto auto 0px auto;
  justify-content: space-evenly;

  @media (max-width: ${(props) => props.theme.breakpoints.desktop}) {
    flex-direction: column;
    top: 90px;
    left: 275px;
    background-image: ${images.IconInfo};
  }

  /* Mobile: zera o offset absoluto do layout desktop (form em fluxo
     normal, sem empurrar pra fora da tela). */
  @media (max-width: 600px) {
    top: 0;
    left: 0;
    width: 100%;
    box-sizing: border-box;
    padding: 0 16px;
  }
`;

export const Icon = styled.img`
  width: 67%;
  height: ${(props) => props.height};
  ${(props) => props.margin && `margin: ${props.margin}`}

`;

export const Title = styled.label`
  font-size: clamp(22px, 4.5vw, 33px);
  font-weight: 900;
  margin: 80px 0 0 0;
  color: ${themes.darkblue};
  position: relative;
  bottom: 380px;
  right: 53%;

  @media (max-width: ${(props) => props.theme.breakpoints.desktop}) {
    position: relative;
    bottom: 350px;
    right: 55%;
  }

  @media (max-width: 600px) {
    position: static;
    bottom: auto;
    right: auto;
    margin: 16px 0 8px;
  }
`;

export const Cmodel = styled.form`
  width: min(450px, 92vw);
  align-items: center;
  justify-content: space-evenly;
`;

export const Label = styled.label`
  font-size: ${(props) => props.size};
  color: ${(props) => props.color};
  ${(props) => props.bold && 'font-weight: bold'}
  ${(props) => props.pointer && 'cursor: pointer'};
  ${(props) => props.hover && ':hover {text-decoration: underline}'}
  ${(props) => props.margin && `margin: ${props.margin}`}
`;

export const CustomLink = styled(Link)`
  font-size: 14px;
  color: grey;
`;

export const LogoContainer = styled.div`
  display: flex;
  width: 450px;
  justify-content: center;
  align-items: center;
`;

export const Logo = styled.img`
  width: 230px;
  height: 270px;
  transform: rotate(90deg);
`;

export const ButtonContainer = styled.div`
//display: grid;
justify-items: center;
grid-template-columns: auto;
grid-template-rows: 30px auto;
  align-items: center;
  justify-content: center;
  margin: ${(props) => (props.margin ? props.margin : '5px 0 100px 0')};
  width: ${(props) => (props.width ? props.width : 'min(520px, 92vw)')};
  height: 155px;

  @media (max-width: ${(props) => props.theme.breakpoints.desktop}) {
    flex-direction: ${(props) => props.first && 'row'};
    margin: ${(props) => props.first && '5px 0'};
  }
`;

export const Wrapper = styled.div`
  align-items: flex-start;
  justify-content: center;
  ${(props) => props.input && 'margin: 10px 0'}
`;

export const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: '16px',
    width: '90%',
    height: '90%',
  }
};


export const WrapperTitle = styled.div`
  font-size: clamp(24px, 4.5vw, 36px);
  padding-top: 9px;
  padding-bottom: 8px;
  font-weight: 900;
`;
